// Mid-run "Powers" HUD strip — pops chips for each active temporary upgrade
// during a wave. Pure render: depends only on `runPowers`, no useFrame.
import React from "react";
import { Zap, Sparkles, Disc, Dog, Rocket, Cloud } from "lucide-react";
import { RUN_POWERS } from "./upgrades";

const POWER_ICONS = { Zap, Sparkles, Disc, Dog, Rocket, Cloud };

export default function PowersHUD({ runPowers }) {
  if (!runPowers) return null;
  const owned = Object.keys(runPowers)
    .filter((id) => (runPowers[id] || 0) > 0 && RUN_POWERS[id])
    .map((id) => ({ id, lvl: runPowers[id], meta: RUN_POWERS[id] }))
    .sort((a, b) => b.lvl - a.lvl);
  if (owned.length === 0) return null;
  return (
    <div className="powers-hud" data-testid="powers-hud">
      {owned.map(({ id, lvl, meta }) => {
        const Icon = POWER_ICONS[meta.icon] || Sparkles;
        return (
          <div
            key={id}
            className="powers-hud-chip"
            title={`${meta.name} — Lv ${lvl}`}
            data-testid={`powers-hud-chip-${id}`}
          >
            <Icon size={13} strokeWidth={2.2} />
            <span className="powers-hud-lvl">{lvl}</span>
          </div>
        );
      })}
    </div>
  );
}
